import { useState, useEffect } from "react";
import toast from "../../../../utils/toast";
import {
  getDomainSettingData,
  saveDomainSettingData,
  getSocialMediaSettingList,
  createSocialMedia,
  getSocialMediaById,
  deleteSocialMediaById,
  getOGTagsSettingList,
  createOGTags,
  getOGTagsById,
  deleteOGTagsById,
  getTwitterCardsTagsList,
  createTwitterCardsTags,
  getTwitterCardsTagsById,
  deleteTwitterCardsTagsById,
} from "../../../../services/admin/adminServices";

export default function WebsiteSetting() {
  const [isDomainSettingData, setDomainSettingData] = useState(null);
  const [isSocialMediaListData, setSocialMediaListData] = useState(null);
  const [form, setForm] = useState({
    domain: "",
    siteTitle: "",
    metaDescription: "",
    metaKeywords: "",
    faviconUrl: "",
    logoUrl: "",
  });
  const [saveLoading, setSaveLoading] = useState(false);
  const [isModalOpenAddSocial, setIsModalOpenAddSocial] = useState(false);
  const [socialForm, setSocialForm] = useState({
    platform: "",
    profileUrl: "",
    icon: "",
  });
  const [socialLoading, setSocialLoading] = useState(false);
  const [socialErrors, setSocialErrors] = useState({});
  const [isModalOpenDeleteSocial, setIsModalOpenDeleteSocial] = useState(false);
  const [selectedSocialId, setSelectedSocialId] = useState(null);
  const [isModalOpenEditSocial, setIsModalOpenEditSocial] = useState(false);
  const [editSocialForm, setEditSocialForm] = useState({
    id: "",
    platform: "",
    profileUrl: "",
    icon: "",
  });
  const [editSocialLoading, setEditSocialLoading] = useState(false);
  const [editSocialErrors, setEditSocialErrors] = useState({});
  const [isOGTagsList, setOGTagsList] = useState([]);
  const [isModalOpenAddOG, setIsModalOpenAddOG] = useState(false);
  const [isModalOpenEditOG, setIsModalOpenEditOG] = useState(false);
  const [isModalOpenDeleteOG, setIsModalOpenDeleteOG] = useState(false);
  const [selectedOGId, setSelectedOGId] = useState(null);
  const [addOGForm, setAddOGForm] = useState({
    tagName: "",
    customTagName: "",
    value: "",
  });
  const [editOGForm, setEditOGForm] = useState({
    id: "",
    tagName: "",
    customTagName: "",
    value: "",
  });
  const [addOGLoading, setAddOGLoading] = useState(false);
  const [editOGLoading, setEditOGLoading] = useState(false);
  const [addOGErrors, setAddOGErrors] = useState({});
  const [editOGErrors, setEditOGErrors] = useState({});
  const [isTwitterTagsList, setTwitterTagsList] = useState([]);
  const [isModalOpenAddTwitter, setIsModalOpenAddTwitter] = useState(false);
  const [isModalOpenEditTwitter, setIsModalOpenEditTwitter] = useState(false);
  const [isModalOpenDeleteTwitter, setIsModalOpenDeleteTwitter] =
    useState(false);
  const [selectedTwitterId, setSelectedTwitterId] = useState(null);
  const [addTwitterForm, setAddTwitterForm] = useState({
    tagName: "twitter:card",
    customTagName: "",
    value: "",
  });
  const [editTwitterForm, setEditTwitterForm] = useState({
    id: "",
    tagName: "",
    customTagName: "",
    value: "",
  });
  const [addTwitterLoading, setAddTwitterLoading] = useState(false);
  const [editTwitterLoading, setEditTwitterLoading] = useState(false);
  const [addTwitterErrors, setAddTwitterErrors] = useState({});
  const [editTwitterErrors, setEditTwitterErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  useEffect(() => {
    fetchDomainSettingData();
    fetchSocialMediaList();
    fetchOGTagsList();
    fetchTwitterTagsList();
  }, []);

  const fetchDomainSettingData = async () => {
    try {
      const res = await getDomainSettingData();
      if (res?.statusCode === 1) {
        setDomainSettingData(res?.data);
        setForm({
          domain: res.data.domain || "",
          siteTitle: res.data.siteTitle || "",
          metaDescription: res.data.metaDescription || "",
          metaKeywords: res.data.metaKeywords || "",
          faviconUrl: res.data.faviconUrl || "",
          logoUrl: res.data.logoUrl || "",
        });
      }
    } catch (err) {
      console.log(
        err.response?.data?.message || "Failed to fetch dashboard data",
        "error",
      );
    }
  };

  const handleSave = async () => {
    setSaveLoading(true);
    try {
      const payload = {
        id: isDomainSettingData?.id,
        domain: form.domain,
        siteTitle: form.siteTitle,
        metaDescription: form.metaDescription,
        metaKeywords: form.metaKeywords,
        faviconUrl: form.faviconUrl,
        logoUrl: form.logoUrl,
        createdAt: isDomainSettingData?.createdAt,
        updatedAt: new Date().toISOString(),
      };
      const res = await saveDomainSettingData(payload);
      if (res.statusCode === 1) {
        toast.success(res.message);
        fetchDomainSettingData();
      } else {
        toast.error(res.message);
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Something went wrong.");
    } finally {
      setSaveLoading(false);
    }
  };

  const fetchSocialMediaList = async () => {
    try {
      const res = await getSocialMediaSettingList();
      if (res?.statusCode === 1) {
        setSocialMediaListData(res?.data);
      }
    } catch (err) {
      console.log(
        err.response?.data?.message || "Failed to fetch dashboard data",
        "error",
      );
    }
  };

  const openAddSocialModal = () => {
    setSocialForm({ platform: "", profileUrl: "" });
    setSocialErrors({});
    setIsModalOpenAddSocial(true);
  };

  const closeAddSocialModal = () => {
    setIsModalOpenAddSocial(false);
    setSocialForm({ platform: "", profileUrl: "" });
    setSocialErrors({});
  };

  const handleSocialChange = (e) => {
    const { name, value } = e.target;
    setSocialForm((prev) => ({ ...prev, [name]: value }));
    setSocialErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleSaveSocial = async () => {
    const e = {};
    if (!socialForm.platform) e.platform = "Platform name is required.";
    if (!socialForm.profileUrl) e.profileUrl = "URL is required.";
    if (Object.keys(e).length) {
      setSocialErrors(e);
      return;
    }

    setSocialLoading(true);
    try {
      const res = await createSocialMedia(socialForm);
      if (res.statusCode === 1) {
        toast.success(res.message);
        closeAddSocialModal();
        fetchSocialMediaList();
      } else {
        toast.error(res.message);
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Something went wrong.");
    } finally {
      setSocialLoading(false);
    }
  };

  const confirmDeleteSocial = async () => {
    try {
      const res = await deleteSocialMediaById(selectedSocialId);
      if (res.statusCode === 1) {
        toast.success(res.message);
        fetchSocialMediaList();
        setIsModalOpenDeleteSocial(false);
        setSelectedSocialId(null);
      } else {
        toast.error(res.message);
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to delete.");
    }
  };
  const openEditSocialModal = async (id) => {
    try {
      const res = await getSocialMediaById(id);
      if (res.statusCode === 1) {
        setEditSocialForm({
          id: res.data.id,
          platform: res.data.platform || "",
          profileUrl: res.data.profileUrl || "",
          icon: res.data.icon || "",
        });
        setEditSocialErrors({});
        setIsModalOpenEditSocial(true);
      }
    } catch (err) {
      toast.error("Failed to load social media details.");
    }
  };

  const closeEditSocialModal = () => {
    setIsModalOpenEditSocial(false);
    setEditSocialForm({ id: "", platform: "", profileUrl: "", icon: "" });
    setEditSocialErrors({});
  };

  const handleEditSocialChange = (e) => {
    const { name, value } = e.target;
    setEditSocialForm((prev) => ({ ...prev, [name]: value }));
    setEditSocialErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleUpdateSocial = async () => {
    const e = {};
    if (!editSocialForm.platform) e.platform = "Platform name is required.";
    if (!editSocialForm.profileUrl) e.profileUrl = "URL is required.";
    if (Object.keys(e).length) {
      setEditSocialErrors(e);
      return;
    }

    setEditSocialLoading(true);
    try {
      const payload = {
        id: editSocialForm.id,
        platform: editSocialForm.platform,
        profileUrl: editSocialForm.profileUrl,
        icon: editSocialForm.icon,
      };
      const res = await createSocialMedia(payload);
      if (res.statusCode === 1) {
        toast.success(res.message);
        closeEditSocialModal();
        fetchSocialMediaList();
      } else {
        toast.error(res.message);
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Something went wrong.");
    } finally {
      setEditSocialLoading(false);
    }
  };

  const OG_TAG_OPTIONS = [
    "og:title",
    "og:description",
    "og:image",
    "og:type",
    "og:url",
    "og:site_name",
    "og:locale",
    "custom",
  ];

  const fetchOGTagsList = async () => {
    try {
      const res = await getOGTagsSettingList();
      if (res.statusCode === 1) setOGTagsList(res.data);
    } catch (err) {
      console.log("Failed to fetch OG tags");
    }
  };

  const openAddOGModal = () => {
    setAddOGForm({ tagName: "og:title", customTagName: "", value: "" });
    setAddOGErrors({});
    setIsModalOpenAddOG(true);
  };

  const closeAddOGModal = () => {
    setIsModalOpenAddOG(false);
    setAddOGForm({ tagName: "", customTagName: "", value: "" });
    setAddOGErrors({});
  };

  const handleAddOGChange = (e) => {
    const { name, value } = e.target;
    setAddOGForm((prev) => ({ ...prev, [name]: value }));
    setAddOGErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleSaveAddOG = async () => {
    const e = {};
    const finalTagName =
      addOGForm.tagName === "custom"
        ? addOGForm.customTagName
        : addOGForm.tagName;
    if (!finalTagName) e.tagName = "Tag name is required.";
    if (!addOGForm.value) e.value = "Value is required.";
    if (Object.keys(e).length) {
      setAddOGErrors(e);
      return;
    }

    setAddOGLoading(true);
    try {
      const res = await createOGTags({
        id: 0,
        tagName: finalTagName,
        value: addOGForm.value,
      });
      if (res.statusCode === 1) {
        toast.success(res.message);
        closeAddOGModal();
        fetchOGTagsList();
      } else {
        toast.error(res.message);
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Something went wrong.");
    } finally {
      setAddOGLoading(false);
    }
  };

  const openEditOGModal = async (id) => {
    try {
      const res = await getOGTagsById(id);
      if (res.statusCode === 1) {
        const d = res.data;
        const isCustom = !OG_TAG_OPTIONS.includes(d.tagName);
        setEditOGForm({
          id: d.id,
          tagName: isCustom ? "custom" : d.tagName,
          customTagName: isCustom ? d.tagName : "",
          value: d.value || "",
        });
        setEditOGErrors({});
        setIsModalOpenEditOG(true);
      }
    } catch (err) {
      toast.error("Failed to load OG tag.");
    }
  };

  const closeEditOGModal = () => {
    setIsModalOpenEditOG(false);
    setEditOGForm({ id: "", tagName: "", customTagName: "", value: "" });
    setEditOGErrors({});
  };

  const handleEditOGChange = (e) => {
    const { name, value } = e.target;
    setEditOGForm((prev) => ({ ...prev, [name]: value }));
    setEditOGErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleSaveEditOG = async () => {
    const e = {};
    const finalTagName =
      editOGForm.tagName === "custom"
        ? editOGForm.customTagName
        : editOGForm.tagName;
    if (!finalTagName) e.tagName = "Tag name is required.";
    if (!editOGForm.value) e.value = "Value is required.";
    if (Object.keys(e).length) {
      setEditOGErrors(e);
      return;
    }

    setEditOGLoading(true);
    try {
      const res = await createOGTags({
        id: editOGForm.id,
        tagName: finalTagName,
        value: editOGForm.value,
      });
      if (res.statusCode === 1) {
        toast.success(res.message);
        closeEditOGModal();
        fetchOGTagsList();
      } else {
        toast.error(res.message);
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Something went wrong.");
    } finally {
      setEditOGLoading(false);
    }
  };

  const confirmDeleteOG = async () => {
    try {
      const res = await deleteOGTagsById(selectedOGId);
      if (res.statusCode === 1) {
        toast.success(res.message);
        setIsModalOpenDeleteOG(false);
        setSelectedOGId(null);
        fetchOGTagsList();
      } else {
        toast.error(res.message);
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Something went wrong.");
    }
  };

  const TWITTER_TAG_OPTIONS = [
    "twitter:card",
    "twitter:title",
    "twitter:description",
    "twitter:image",
    "twitter:site",
    "custom",
  ];
  const fetchTwitterTagsList = async () => {
    try {
      const res = await getTwitterCardsTagsList();
      if (res.statusCode === 1) setTwitterTagsList(res.data);
    } catch (err) {
      console.log("Failed to fetch twitter tags");
    }
  };

  const openAddTwitterModal = () => {
    setAddTwitterForm({
      tagName: "twitter:card",
      customTagName: "",
      value: "",
    });
    setAddTwitterErrors({});
    setIsModalOpenAddTwitter(true);
  };

  const closeAddTwitterModal = () => {
    setIsModalOpenAddTwitter(false);
    setAddTwitterForm({
      tagName: "twitter:card",
      customTagName: "",
      value: "",
    });
    setAddTwitterErrors({});
  };

  const handleAddTwitterChange = (e) => {
    const { name, value } = e.target;
    setAddTwitterForm((prev) => ({ ...prev, [name]: value }));
    setAddTwitterErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleSaveAddTwitter = async () => {
    const e = {};
    const finalTagName =
      addTwitterForm.tagName === "custom"
        ? addTwitterForm.customTagName
        : addTwitterForm.tagName;
    if (!finalTagName) e.tagName = "Tag name is required.";
    if (!addTwitterForm.value) e.value = "Value is required.";
    if (Object.keys(e).length) {
      setAddTwitterErrors(e);
      return;
    }

    setAddTwitterLoading(true);
    try {
      const res = await createTwitterCardsTags({
        id: 0,
        tagName: finalTagName,
        value: addTwitterForm.value,
      });
      if (res.statusCode === 1) {
        toast.success(res.message);
        closeAddTwitterModal();
        fetchTwitterTagsList();
      } else {
        toast.error(res.message);
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Something went wrong.");
    } finally {
      setAddTwitterLoading(false);
    }
  };

  const openEditTwitterModal = async (id) => {
    try {
      const res = await getTwitterCardsTagsById(id);
      if (res.statusCode === 1) {
        const d = res.data;
        const isCustom = !TWITTER_TAG_OPTIONS.includes(d.tagName);
        setEditTwitterForm({
          id: d.id,
          tagName: isCustom ? "custom" : d.tagName,
          customTagName: isCustom ? d.tagName : "",
          value: d.value || "",
        });
        setEditTwitterErrors({});
        setIsModalOpenEditTwitter(true);
      }
    } catch (err) {
      toast.error("Failed to load twitter tag.");
    }
  };

  const closeEditTwitterModal = () => {
    setIsModalOpenEditTwitter(false);
    setEditTwitterForm({ id: "", tagName: "", customTagName: "", value: "" });
    setEditTwitterErrors({});
  };

  const handleEditTwitterChange = (e) => {
    const { name, value } = e.target;
    setEditTwitterForm((prev) => ({ ...prev, [name]: value }));
    setEditTwitterErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleSaveEditTwitter = async () => {
    const e = {};
    const finalTagName =
      editTwitterForm.tagName === "custom"
        ? editTwitterForm.customTagName
        : editTwitterForm.tagName;
    if (!finalTagName) e.tagName = "Tag name is required.";
    if (!editTwitterForm.value) e.value = "Value is required.";
    if (Object.keys(e).length) {
      setEditTwitterErrors(e);
      return;
    }

    setEditTwitterLoading(true);
    try {
      const res = await createTwitterCardsTags({
        id: editTwitterForm.id,
        tagName: finalTagName,
        value: editTwitterForm.value,
      });
      if (res.statusCode === 1) {
        toast.success(res.message);
        closeEditTwitterModal();
        fetchTwitterTagsList();
      } else {
        toast.error(res.message);
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Something went wrong.");
    } finally {
      setEditTwitterLoading(false);
    }
  };

  const confirmDeleteTwitter = async () => {
    try {
      const res = await deleteTwitterCardsTagsById(selectedTwitterId);
      if (res.statusCode === 1) {
        toast.success(res.message);
        setIsModalOpenDeleteTwitter(false);
        setSelectedTwitterId(null);
        fetchTwitterTagsList();
      } else {
        toast.error(res.message);
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Something went wrong.");
    }
  };

  return (
    <>
      <div className="main">
        <div className="topbar">
          <div>
            <div className="page-title" id="page-title">
              Website Settings
            </div>
            <div className="page-sub" id="page-sub">
              Domain, SEO, social media &amp; Open Graph
            </div>
          </div>
          <div className="topbar-right" id="topbar-right" />
        </div>
        <div className="content" id="content-area">
          <div className="card mb16">
            <div className="card-title">Domain &amp; Basic Settings</div>
            <div className="form-grid">
              <div className="form-group">
                <label>Domain *</label>
                <input
                  type="text"
                  name="domain"
                  value={form.domain}
                  onChange={handleChange}
                  placeholder="yourdomain.com"
                />
              </div>
              <div className="form-group">
                <label>Site Title *</label>
                <input
                  type="text"
                  name="siteTitle"
                  value={form.siteTitle}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label>Meta Description</label>
                <input
                  type="text"
                  name="metaDescription"
                  value={form.metaDescription}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label>Meta Keywords</label>
                <input
                  type="text"
                  name="metaKeywords"
                  value={form.metaKeywords}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label>Favicon URL</label>
                <input
                  type="text"
                  name="faviconUrl"
                  value={form.faviconUrl}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label>Logo URL</label>
                <input
                  type="text"
                  name="logoUrl"
                  value={form.logoUrl}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div style={{ marginTop: 14 }}>
              <button
                className="btn btn-primary"
                onClick={handleSave}
                disabled={saveLoading}
              >
                {saveLoading ? "Saving..." : "Save Domain Settings"}
              </button>
            </div>
          </div>
          <div className="card mb16">
            <div className="flex-between mb12">
              <div className="card-title" style={{ margin: 0 }}>
                Social Media Links
              </div>
              <button
                className="btn btn-primary btn-sm"
                onClick={openAddSocialModal}
              >
                + Add Social Media
              </button>
            </div>

            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              {isSocialMediaListData?.length === 0 ? (
                <div
                  style={{
                    fontSize: 12,
                    color: "var(--text-tertiary)",
                    padding: "10px 0",
                  }}
                >
                  No social media links added.
                </div>
              ) : (
                isSocialMediaListData?.map((item) => (
                  <div
                    key={item.id}
                    style={{
                      display: "grid",
                      gridTemplateColumns: "40px 140px 1fr 90px",
                      gap: 10,
                      alignItems: "center",
                      padding: "10px 12px",
                      background: "var(--bg-secondary)",
                      borderRadius: "var(--radius-md)",
                      border: "0.5px solid var(--border-light)",
                    }}
                  >
                    <span style={{ fontSize: 18, textAlign: "center" }}>
                      {item.icon}
                    </span>

                    <span
                      style={{
                        fontSize: 11,
                        color: "var(--text-secondary)",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {item.platform}
                    </span>

                    <span
                      style={{
                        fontSize: 11,
                        color: "var(--text-secondary)",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {item.profileUrl}
                    </span>
                    <div style={{ display: "flex", gap: 4 }}>
                      <button
                        className="btn btn-xs"
                        onClick={() => openEditSocialModal(item.id)}
                      >
                        Edit
                      </button>
                      <button
                        className="btn btn-xs btn-danger"
                        onClick={() => {
                          setSelectedSocialId(item.id);
                          setIsModalOpenDeleteSocial(true);
                        }}
                      >
                        Del
                      </button>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>

          <div className="card mb16">
            <div className="flex-between mb12">
              <div className="card-title" style={{ margin: 0 }}>
                Open Graph / Meta Tags
              </div>
              <button
                className="btn btn-primary btn-sm"
                onClick={openAddOGModal}
              >
                + Add OG Tag
              </button>
            </div>
            <div className="info-box mb10">
              OG tags control how your site appears when shared on social media
              and messaging apps.
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
              {isOGTagsList?.length === 0 ? (
                <div
                  style={{
                    fontSize: 12,
                    color: "var(--text-tertiary)",
                    padding: "10px 0",
                  }}
                >
                  No OG tags added.
                </div>
              ) : (
                isOGTagsList?.map((tag) => (
                  <div
                    key={tag.id}
                    style={{
                      display: "grid",
                      gridTemplateColumns: "200px 1fr 90px",
                      gap: 10,
                      alignItems: "center",
                      padding: "10px 12px",
                      background: "var(--bg-secondary)",
                      borderRadius: "var(--radius-md)",
                      border: "0.5px solid var(--border-light)",
                    }}
                  >
                    <span
                      style={{
                        fontSize: 12,
                        fontWeight: 600,
                        color: "var(--blue)",
                      }}
                    >
                      {tag.tagName}
                    </span>
                    <span
                      style={{
                        fontSize: 12,
                        color: "var(--text-secondary)",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {tag.value}
                    </span>
                    <div style={{ display: "flex", gap: 4 }}>
                      <button
                        className="btn btn-xs"
                        onClick={() => openEditOGModal(tag.id)}
                      >
                        Edit
                      </button>
                      <button
                        className="btn btn-xs btn-danger"
                        onClick={() => {
                          setSelectedOGId(tag.id);
                          setIsModalOpenDeleteOG(true);
                        }}
                      >
                        Del
                      </button>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>

          <div className="card">
            <div className="flex-between mb12">
              <div className="card-title" style={{ margin: 0 }}>
                🐦 Twitter Card Tags
              </div>
              <button
                className="btn btn-primary btn-sm"
                onClick={openAddTwitterModal}
              >
                + Add Twitter Tag
              </button>
            </div>
            <div className="info-box mb10">
              Twitter Card tags control how your site looks when shared on
              Twitter/X. Use <code>twitter:card</code>,{" "}
              <code>twitter:title</code>, <code>twitter:description</code>,{" "}
              <code>twitter:image</code>, <code>twitter:site</code>.
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
              {isTwitterTagsList?.length === 0 ? (
                <div
                  style={{
                    fontSize: 12,
                    color: "var(--text-tertiary)",
                    padding: "10px 0",
                  }}
                >
                  No Twitter tags added.
                </div>
              ) : (
                isTwitterTagsList?.map((tag) => (
                  <div
                    key={tag.id}
                    style={{
                      display: "grid",
                      gridTemplateColumns: "200px 1fr 90px",
                      gap: 10,
                      alignItems: "center",
                      padding: "10px 12px",
                      background: "var(--bg-secondary)",
                      borderRadius: "var(--radius-md)",
                      border: "0.5px solid var(--border-light)",
                    }}
                  >
                    <span
                      style={{
                        fontSize: 12,
                        fontWeight: 600,
                        color: "#1DA1F2",
                      }}
                    >
                      {tag.tagName}
                    </span>
                    <span
                      style={{
                        fontSize: 12,
                        color: "var(--text-secondary)",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {tag.value}
                    </span>
                    <div style={{ display: "flex", gap: 4 }}>
                      <button
                        className="btn btn-xs"
                        onClick={() => openEditTwitterModal(tag.id)}
                      >
                        Edit
                      </button>
                      <button
                        className="btn btn-xs btn-danger"
                        onClick={() => {
                          setSelectedTwitterId(tag.id);
                          setIsModalOpenDeleteTwitter(true);
                        }}
                      >
                        Del
                      </button>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>

        {isModalOpenAddSocial && (
          <div className="modal-overlay open">
            <div className="modal" style={{ width: 480 }}>
              <div className="modal-header">
                <div className="modal-title">Add Social Media</div>
                <button className="modal-close" onClick={closeAddSocialModal}>
                  ✕
                </button>
              </div>
              <div className="modal-body">
                <div className="info-box">
                  Add a social media link that appears in the platform footer
                  and contact page.
                </div>

                <div className="form-group mb12">
                  <label>Social Media Name *</label>
                  <input
                    type="text"
                    name="platform"
                    value={socialForm.platform}
                    onChange={handleSocialChange}
                    placeholder="e.g. Facebook, Instagram, LinkedIn, Twitter, YouTube…"
                    style={
                      socialErrors.platform ? { borderColor: "#dc2626" } : {}
                    }
                  />
                  {socialErrors.platform && (
                    <span style={{ color: "#dc2626", fontSize: 11 }}>
                      {socialErrors.platform}
                    </span>
                  )}
                  <div className="input-hint">
                    This label is shown in the footer
                  </div>
                </div>

                <div className="form-group mb12">
                  <label>Icon / Emoji</label>
                  <input
                    type="text"
                    name="icon"
                    value={socialForm.icon}
                    onChange={handleSocialChange}
                    placeholder="e.g. 📘 🐦 📸 💼 ▶️"
                  />
                  <div className="input-hint">
                    Paste any emoji as the platform icon — shown next to the
                    link
                  </div>
                </div>

                <div className="form-group mb12">
                  <label>Profile / Page URL *</label>
                  <input
                    type="url"
                    name="profileUrl"
                    value={socialForm.profileUrl}
                    onChange={handleSocialChange}
                    placeholder="https://facebook.com/yourpage"
                    style={
                      socialErrors.profileUrl ? { borderColor: "#dc2626" } : {}
                    }
                  />
                  {socialErrors.profileUrl && (
                    <span style={{ color: "#dc2626", fontSize: 11 }}>
                      {socialErrors.profileUrl}
                    </span>
                  )}
                </div>
              </div>
              <div className="modal-footer">
                <button
                  className="btn"
                  onClick={closeAddSocialModal}
                  disabled={socialLoading}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-primary"
                  onClick={handleSaveSocial}
                  disabled={socialLoading}
                >
                  {socialLoading ? "Saving..." : "Save Social Media"}
                </button>
              </div>
            </div>
          </div>
        )}

        {isModalOpenDeleteSocial && (
          <div className="modal-overlay open">
            <div className="modal" style={{ width: 400 }}>
              <div className="modal-header">
                <div className="modal-title">Confirm Delete</div>
                <button
                  className="modal-close"
                  onClick={() => setIsModalOpenDeleteSocial(false)}
                >
                  ✕
                </button>
              </div>
              <div className="modal-body">
                <p style={{ fontSize: 14, color: "var(--text-primary)" }}>
                  Are you sure you want to delete this social media link? This
                  action cannot be undone.
                </p>
              </div>
              <div className="modal-footer">
                <button
                  className="btn"
                  onClick={() => setIsModalOpenDeleteSocial(false)}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-danger"
                  onClick={confirmDeleteSocial}
                >
                  Yes, Delete
                </button>
              </div>
            </div>
          </div>
        )}

        {isModalOpenEditSocial && (
          <div className="modal-overlay open">
            <div className="modal" style={{ width: 480 }}>
              <div className="modal-header">
                <div className="modal-title">Edit Social Media</div>
                <button className="modal-close" onClick={closeEditSocialModal}>
                  ✕
                </button>
              </div>
              <div className="modal-body">
                <div className="info-box">
                  Update the social media link that appears in the platform
                  footer and contact page.
                </div>

                <div className="form-group mb12">
                  <label>Social Media Name *</label>
                  <input
                    type="text"
                    name="platform"
                    value={editSocialForm.platform}
                    onChange={handleEditSocialChange}
                    placeholder="e.g. Facebook, Instagram, LinkedIn…"
                    style={
                      editSocialErrors.platform
                        ? { borderColor: "#dc2626" }
                        : {}
                    }
                  />
                  {editSocialErrors.platform && (
                    <span style={{ color: "#dc2626", fontSize: 11 }}>
                      {editSocialErrors.platform}
                    </span>
                  )}
                  <div className="input-hint">
                    This label is shown in the footer
                  </div>
                </div>

                <div className="form-group mb12">
                  <label>Icon / Emoji</label>
                  <input
                    type="text"
                    name="icon"
                    value={editSocialForm.icon}
                    onChange={handleEditSocialChange}
                    placeholder="e.g. 📘 🐦 📸 💼 ▶️"
                  />
                  <div className="input-hint">
                    Paste any emoji as the platform icon — shown next to the
                    link
                  </div>
                </div>

                {editSocialForm.icon && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                      padding: "8px 12px",
                      background: "var(--bg-secondary)",
                      borderRadius: "var(--radius-md)",
                      marginBottom: 12,
                      fontSize: 13,
                    }}
                  >
                    <span style={{ fontSize: 20 }}>{editSocialForm.icon}</span>
                    <span style={{ color: "var(--text-secondary)" }}>
                      {editSocialForm.platform || "Platform Name"}
                    </span>
                  </div>
                )}

                <div className="form-group mb12">
                  <label>Profile / Page URL *</label>
                  <input
                    type="url"
                    name="profileUrl"
                    value={editSocialForm.profileUrl}
                    onChange={handleEditSocialChange}
                    placeholder="https://facebook.com/yourpage"
                    style={
                      editSocialErrors.profileUrl
                        ? { borderColor: "#dc2626" }
                        : {}
                    }
                  />
                  {editSocialErrors.profileUrl && (
                    <span style={{ color: "#dc2626", fontSize: 11 }}>
                      {editSocialErrors.profileUrl}
                    </span>
                  )}
                </div>
              </div>
              <div className="modal-footer">
                <button
                  className="btn"
                  onClick={closeEditSocialModal}
                  disabled={editSocialLoading}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-primary"
                  onClick={handleUpdateSocial}
                  disabled={editSocialLoading}
                >
                  {editSocialLoading ? "Saving..." : "Save Changes"}
                </button>
              </div>
            </div>
          </div>
        )}

        {isModalOpenAddOG && (
          <div className="modal-overlay open">
            <div className="modal" style={{ width: 520 }}>
              <div className="modal-header">
                <div className="modal-title">Add Open Graph Tag</div>
                <button className="modal-close" onClick={closeAddOGModal}>
                  ✕
                </button>
              </div>
              <div className="modal-body">
                <div className="info-box">
                  Open Graph tags control how your pages appear when shared on
                  Facebook, WhatsApp, LinkedIn, Twitter and other platforms.
                </div>

                <div className="form-group mb12">
                  <label>Tag Name *</label>
                  <select
                    name="tagName"
                    value={addOGForm.tagName}
                    onChange={handleAddOGChange}
                    style={{ width: "100%" }}
                  >
                    {OG_TAG_OPTIONS.map((opt) => (
                      <option key={opt} value={opt}>
                        {opt === "custom" ? "Custom…" : opt}
                      </option>
                    ))}
                  </select>
                  {addOGForm.tagName === "custom" && (
                    <input
                      type="text"
                      name="customTagName"
                      value={addOGForm.customTagName}
                      onChange={handleAddOGChange}
                      placeholder="Enter tag name (e.g. og:video)"
                      style={{
                        marginTop: 6,
                        ...(addOGErrors.tagName
                          ? { borderColor: "#dc2626" }
                          : {}),
                      }}
                    />
                  )}
                  {addOGErrors.tagName && (
                    <span style={{ color: "#dc2626", fontSize: 11 }}>
                      {addOGErrors.tagName}
                    </span>
                  )}
                </div>

                <div className="form-group mb12">
                  <label>Value *</label>
                  <textarea
                    name="value"
                    value={addOGForm.value}
                    onChange={handleAddOGChange}
                    placeholder="e.g. MyRentMitra — Best Tenant Management Platform"
                    style={{
                      minHeight: 80,
                      ...(addOGErrors.value ? { borderColor: "#dc2626" } : {}),
                    }}
                  />
                  {addOGErrors.value && (
                    <span style={{ color: "#dc2626", fontSize: 11 }}>
                      {addOGErrors.value}
                    </span>
                  )}
                  <div className="input-hint">
                    This value will be inserted as the content attribute of the
                    meta tag
                  </div>
                </div>

                <div
                  style={{
                    background: "var(--bg-secondary)",
                    borderRadius: "var(--radius-md)",
                    padding: "10px 12px",
                    fontSize: 11,
                    color: "var(--text-secondary)",
                  }}
                >
                  Preview:{" "}
                  <code style={{ color: "var(--blue)" }}>
                    &lt;meta property="
                    <span>
                      {addOGForm.tagName === "custom"
                        ? addOGForm.customTagName || "og:..."
                        : addOGForm.tagName}
                    </span>
                    " content="<span>{addOGForm.value || "Your value"}</span>
                    "/&gt;
                  </code>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  className="btn"
                  onClick={closeAddOGModal}
                  disabled={addOGLoading}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-primary"
                  onClick={handleSaveAddOG}
                  disabled={addOGLoading}
                >
                  {addOGLoading ? "Saving..." : "Save OG Tag"}
                </button>
              </div>
            </div>
          </div>
        )}

        {isModalOpenEditOG && (
          <div className="modal-overlay open">
            <div className="modal" style={{ width: 520 }}>
              <div className="modal-header">
                <div className="modal-title">Edit Open Graph Tag</div>
                <button className="modal-close" onClick={closeEditOGModal}>
                  ✕
                </button>
              </div>
              <div className="modal-body">
                <div className="info-box">
                  Open Graph tags control how your pages appear when shared on
                  Facebook, WhatsApp, LinkedIn, Twitter and other platforms.
                </div>

                <div className="form-group mb12">
                  <label>Tag Name *</label>
                  <select
                    name="tagName"
                    value={editOGForm.tagName}
                    onChange={handleEditOGChange}
                    style={{ width: "100%" }}
                  >
                    {OG_TAG_OPTIONS.map((opt) => (
                      <option key={opt} value={opt}>
                        {opt === "custom" ? "Custom…" : opt}
                      </option>
                    ))}
                  </select>
                  {editOGForm.tagName === "custom" && (
                    <input
                      type="text"
                      name="customTagName"
                      value={editOGForm.customTagName}
                      onChange={handleEditOGChange}
                      placeholder="Enter tag name (e.g. og:video)"
                      style={{
                        marginTop: 6,
                        ...(editOGErrors.tagName
                          ? { borderColor: "#dc2626" }
                          : {}),
                      }}
                    />
                  )}
                  {editOGErrors.tagName && (
                    <span style={{ color: "#dc2626", fontSize: 11 }}>
                      {editOGErrors.tagName}
                    </span>
                  )}
                </div>

                <div className="form-group mb12">
                  <label>Value *</label>
                  <textarea
                    name="value"
                    value={editOGForm.value}
                    onChange={handleEditOGChange}
                    placeholder="e.g. MyRentMitra — Best Tenant Management Platform"
                    style={{
                      minHeight: 80,
                      ...(editOGErrors.value ? { borderColor: "#dc2626" } : {}),
                    }}
                  />
                  {editOGErrors.value && (
                    <span style={{ color: "#dc2626", fontSize: 11 }}>
                      {editOGErrors.value}
                    </span>
                  )}
                  <div className="input-hint">
                    This value will be inserted as the content attribute of the
                    meta tag
                  </div>
                </div>

                <div
                  style={{
                    background: "var(--bg-secondary)",
                    borderRadius: "var(--radius-md)",
                    padding: "10px 12px",
                    fontSize: 11,
                    color: "var(--text-secondary)",
                  }}
                >
                  Preview:{" "}
                  <code style={{ color: "var(--blue)" }}>
                    &lt;meta property="
                    <span>
                      {editOGForm.tagName === "custom"
                        ? editOGForm.customTagName || "og:..."
                        : editOGForm.tagName}
                    </span>
                    " content="<span>{editOGForm.value || "Your value"}</span>
                    "/&gt;
                  </code>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  className="btn"
                  onClick={closeEditOGModal}
                  disabled={editOGLoading}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-primary"
                  onClick={handleSaveEditOG}
                  disabled={editOGLoading}
                >
                  {editOGLoading ? "Saving..." : "Save Changes"}
                </button>
              </div>
            </div>
          </div>
        )}

        {isModalOpenDeleteOG && (
          <div className="modal-overlay open">
            <div className="modal" style={{ width: 400 }}>
              <div className="modal-header">
                <div className="modal-title">Confirm Delete</div>
                <button
                  className="modal-close"
                  onClick={() => setIsModalOpenDeleteOG(false)}
                >
                  ✕
                </button>
              </div>
              <div className="modal-body">
                <p style={{ fontSize: 14, color: "var(--text-primary)" }}>
                  Are you sure you want to delete this OG tag? This action
                  cannot be undone.
                </p>
              </div>
              <div className="modal-footer">
                <button
                  className="btn"
                  onClick={() => setIsModalOpenDeleteOG(false)}
                >
                  Cancel
                </button>
                <button className="btn btn-danger" onClick={confirmDeleteOG}>
                  Yes, Delete
                </button>
              </div>
            </div>
          </div>
        )}

        {isModalOpenAddTwitter && (
          <div className="modal-overlay open">
            <div className="modal" style={{ width: 520 }}>
              <div className="modal-header">
                <div className="modal-title">Add Twitter Card Tag</div>
                <button className="modal-close" onClick={closeAddTwitterModal}>
                  ✕
                </button>
              </div>
              <div className="modal-body">
                <div className="info-box">
                  Twitter Card tags control how your pages appear when shared on
                  Twitter/X.
                </div>

                <div className="form-group mb12">
                  <label>Tag Name *</label>
                  <select
                    name="tagName"
                    value={addTwitterForm.tagName}
                    onChange={handleAddTwitterChange}
                    style={{ width: "100%" }}
                  >
                    {TWITTER_TAG_OPTIONS.map((opt) => (
                      <option key={opt} value={opt}>
                        {opt === "custom" ? "Custom…" : opt}
                      </option>
                    ))}
                  </select>
                  {addTwitterForm.tagName === "custom" && (
                    <input
                      type="text"
                      name="customTagName"
                      value={addTwitterForm.customTagName}
                      onChange={handleAddTwitterChange}
                      placeholder="Enter tag name (e.g. twitter:creator)"
                      style={{
                        marginTop: 6,
                        ...(addTwitterErrors.tagName
                          ? { borderColor: "#dc2626" }
                          : {}),
                      }}
                    />
                  )}
                  {addTwitterErrors.tagName && (
                    <span style={{ color: "#dc2626", fontSize: 11 }}>
                      {addTwitterErrors.tagName}
                    </span>
                  )}
                </div>

                <div className="form-group mb12">
                  <label>Value *</label>
                  <textarea
                    name="value"
                    value={addTwitterForm.value}
                    onChange={handleAddTwitterChange}
                    placeholder="e.g. summary_large_image"
                    style={{
                      minHeight: 80,
                      ...(addTwitterErrors.value
                        ? { borderColor: "#dc2626" }
                        : {}),
                    }}
                  />
                  {addTwitterErrors.value && (
                    <span style={{ color: "#dc2626", fontSize: 11 }}>
                      {addTwitterErrors.value}
                    </span>
                  )}
                  <div className="input-hint">
                    This value will be inserted as the content attribute of the
                    meta tag
                  </div>
                </div>

                <div
                  style={{
                    background: "var(--bg-secondary)",
                    borderRadius: "var(--radius-md)",
                    padding: "10px 12px",
                    fontSize: 11,
                    color: "var(--text-secondary)",
                  }}
                >
                  Preview:{" "}
                  <code style={{ color: "#1DA1F2" }}>
                    &lt;meta name="
                    <span>
                      {addTwitterForm.tagName === "custom"
                        ? addTwitterForm.customTagName || "twitter:..."
                        : addTwitterForm.tagName}
                    </span>
                    " content="
                    <span>{addTwitterForm.value || "Your value"}</span>"/&gt;
                  </code>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  className="btn"
                  onClick={closeAddTwitterModal}
                  disabled={addTwitterLoading}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-primary"
                  onClick={handleSaveAddTwitter}
                  disabled={addTwitterLoading}
                >
                  {addTwitterLoading ? "Saving..." : "Save Twitter Tag"}
                </button>
              </div>
            </div>
          </div>
        )}

        {isModalOpenEditTwitter && (
          <div className="modal-overlay open">
            <div className="modal" style={{ width: 520 }}>
              <div className="modal-header">
                <div className="modal-title">Edit Twitter Card Tag</div>
                <button className="modal-close" onClick={closeEditTwitterModal}>
                  ✕
                </button>
              </div>
              <div className="modal-body">
                <div className="info-box">
                  Twitter Card tags control how your pages appear when shared on
                  Twitter/X.
                </div>

                <div className="form-group mb12">
                  <label>Tag Name *</label>
                  <select
                    name="tagName"
                    value={editTwitterForm.tagName}
                    onChange={handleEditTwitterChange}
                    style={{ width: "100%" }}
                  >
                    {TWITTER_TAG_OPTIONS.map((opt) => (
                      <option key={opt} value={opt}>
                        {opt === "custom" ? "Custom…" : opt}
                      </option>
                    ))}
                  </select>
                  {editTwitterForm.tagName === "custom" && (
                    <input
                      type="text"
                      name="customTagName"
                      value={editTwitterForm.customTagName}
                      onChange={handleEditTwitterChange}
                      placeholder="Enter tag name (e.g. twitter:creator)"
                      style={{
                        marginTop: 6,
                        ...(editTwitterErrors.tagName
                          ? { borderColor: "#dc2626" }
                          : {}),
                      }}
                    />
                  )}
                  {editTwitterErrors.tagName && (
                    <span style={{ color: "#dc2626", fontSize: 11 }}>
                      {editTwitterErrors.tagName}
                    </span>
                  )}
                </div>

                <div className="form-group mb12">
                  <label>Value *</label>
                  <textarea
                    name="value"
                    value={editTwitterForm.value}
                    onChange={handleEditTwitterChange}
                    placeholder="e.g. summary_large_image"
                    style={{
                      minHeight: 80,
                      ...(editTwitterErrors.value
                        ? { borderColor: "#dc2626" }
                        : {}),
                    }}
                  />
                  {editTwitterErrors.value && (
                    <span style={{ color: "#dc2626", fontSize: 11 }}>
                      {editTwitterErrors.value}
                    </span>
                  )}
                  <div className="input-hint">
                    This value will be inserted as the content attribute of the
                    meta tag
                  </div>
                </div>

                <div
                  style={{
                    background: "var(--bg-secondary)",
                    borderRadius: "var(--radius-md)",
                    padding: "10px 12px",
                    fontSize: 11,
                    color: "var(--text-secondary)",
                  }}
                >
                  Preview:{" "}
                  <code style={{ color: "#1DA1F2" }}>
                    &lt;meta name="
                    <span>
                      {editTwitterForm.tagName === "custom"
                        ? editTwitterForm.customTagName || "twitter:..."
                        : editTwitterForm.tagName}
                    </span>
                    " content="
                    <span>{editTwitterForm.value || "Your value"}</span>"/&gt;
                  </code>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  className="btn"
                  onClick={closeEditTwitterModal}
                  disabled={editTwitterLoading}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-primary"
                  onClick={handleSaveEditTwitter}
                  disabled={editTwitterLoading}
                >
                  {editTwitterLoading ? "Saving..." : "Save Changes"}
                </button>
              </div>
            </div>
          </div>
        )}

        {isModalOpenDeleteTwitter && (
          <div className="modal-overlay open">
            <div className="modal" style={{ width: 400 }}>
              <div className="modal-header">
                <div className="modal-title">Confirm Delete</div>
                <button
                  className="modal-close"
                  onClick={() => setIsModalOpenDeleteTwitter(false)}
                >
                  ✕
                </button>
              </div>
              <div className="modal-body">
                <p style={{ fontSize: 14, color: "var(--text-primary)" }}>
                  Are you sure you want to delete this Twitter tag? This action
                  cannot be undone.
                </p>
              </div>
              <div className="modal-footer">
                <button
                  className="btn"
                  onClick={() => setIsModalOpenDeleteTwitter(false)}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-danger"
                  onClick={confirmDeleteTwitter}
                >
                  Yes, Delete
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
